import type { PublicSection } from '@/lib/types/public-pages';
import { SECTION_RENDERERS, isRenderableSectionType } from '../section-renderers/section-renderer.registry';

/**
 * Renders a page's sections in order, dispatching each to its registered
 * renderer by `type` (MYN-197, MYN-198). An unrecognized type is skipped and
 * logged rather than crashing the page - the backend can never send a type
 * this repo's registry hasn't caught up with yet, but a partial page beats a
 * blank one.
 */
export function PageSections({ sections, pageSlug }: { sections: PublicSection[]; pageSlug: string }) {
  return (
    <>
      {sections.map((section) => {
        if (!isRenderableSectionType(section.type)) {
          // eslint-disable-next-line no-console
          console.error(`No renderer registered for section type "${section.type}" (key: ${section.key})`);
          return null;
        }
        const Renderer = SECTION_RENDERERS[section.type];
        return <Renderer key={section.id} section={section} pageSlug={pageSlug} />;
      })}
    </>
  );
}
